import type { PageBlockMedia } from "@/types/page-block";
import { extractCloudinaryAssetUrl } from "./utils/asset-resolver";

export interface RawMedia {
  id?: string;
  __typename?: string | null;
  sys?: { id: string };
  alternativeText?: string | null;
  caption?: string | null;
  image?: unknown;
  internalName?: string | null;
  video?: unknown;
  externalVideoUrl?: string | null;
}

/**
 * Converts raw Contentful media data to PageBlockMedia format.
 * Supports both Image and Video types.
 */
export function adaptMedia(
  media: RawMedia | undefined
): PageBlockMedia | undefined {
  if (!media?.__typename) {
    return;
  }

  let cloudinaryAssetSource: unknown;
  let externalAssetSource: string | null = null;
  let mediaType: PageBlockMedia["type"];
  const altText = media.alternativeText ?? media.caption ?? "";

  switch (media.__typename) {
    case "MediaImage": {
      cloudinaryAssetSource = media.image;
      mediaType = "Image";
      break;
    }

    case "MediaVideo": {
      cloudinaryAssetSource = media.video;
      externalAssetSource = media.externalVideoUrl as string;
      mediaType = "Video";
      break;
    }

    default:
      return;
  }

  let src = "";
  if (cloudinaryAssetSource) {
    src = extractCloudinaryAssetUrl(cloudinaryAssetSource);
  } else if (externalAssetSource) {
    src = externalAssetSource;
  }

  if (!src) {
    return;
  }

  return {
    __typename: media.__typename,
    sys: media.sys,
    id: media.id ?? "",
    internalName: media.internalName ?? "",
    src,
    alt: altText,
    type: mediaType,
  };
}
